<script>
import { Switch, ConfigProvider } from 'ant-design-vue';
import BaseIcon from '@/rex-components/BaseIcon.vue';

export default {
  emits: ['onChange'],
  components: { SwitchComp: Switch, ConfigProvider, BaseIcon },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    inverseValues: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div>
    <SwitchComp
      :checked="checked"
      :disabled="disabled"
      :loading="loading"
      @change="(val) => $emit('onChange', val)"
      :checkedValue="!inverseValues"
      :unCheckedValue="inverseValues"
    >
      <template #checkedChildren>
        <slot name="checkedChildren"></slot>
      </template>
      <template #unCheckedChildren>
        <slot name="uncheckedChildren"></slot>
      </template>
    </SwitchComp>
  </div>
</template>

<style lang="scss" scoped></style>
